import type { SavingsDirectBillingReportRun } from '@interfaces/Savings.interface';
import BaseApiClient from '../BaseApiClient';
import {
  SAVINGS_API_VERSION_HEADERS,
  toSavingsListResponse
} from '../savings-reference-resource';
import type { ListDataParams, ListDataResponse } from '../types';

export class ApiSavingsDirectBilling extends BaseApiClient {
  async list(
    listData: ListDataParams
  ): Promise<ListDataResponse<SavingsDirectBillingReportRun>> {
    const res = await this.client.getList('/direct-billing-reports', listData, {
      headers: SAVINGS_API_VERSION_HEADERS
    });

    return toSavingsListResponse<SavingsDirectBillingReportRun>(res.data);
  }
}

export { savingsDirectBillingQueryKeys } from './query-keys';
export { useSavingsDirectBillingReportsListQuery } from './use-savings-direct-billing-queries';
